import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function RecoverySuccessStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "success-heading", children: [_jsx("h3", { id: "success-heading", children: t('recovery.success.heading') }), _jsx("p", { children: t('recovery.success.body') }), _jsx("p", { children: _jsxs("strong", { children: [t('recovery.success.tier_recovered_label'), ' ', t(`recovery.tier_election.option.${props.tier}.label`)] }) })] }));
}
//# sourceMappingURL=success-step.js.map